<template>
  <v-container fluid class="perfil-change-page py-6">
    <v-row justify="center" dense>
      <v-col cols="12" lg="10" xl="9">
        <v-card class="pc-hero" elevation="1">
          <v-card-text>
            <div class="pc-hero-content">
              <v-avatar size="72" color="white" class="pc-avatar">
                <v-icon size="38" color="light-blue darken-2">mdi-shield-key-outline</v-icon>
              </v-avatar>
              <div>
                <div class="text-h5 font-weight-bold pc-title">Actualice sus datos de acceso</div>
                <div class="text-body-2 pc-subtitle">
                  Para continuar usando el portal, registre una clave personal diferente a su documento de identidad.
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" lg="5" xl="4">
        <v-card outlined class="pc-card fill-height">
          <v-card-title class="pc-card-title">
            <v-icon color="light-blue darken-2" class="mr-2">mdi-information-outline</v-icon>
            Seguridad de la cuenta
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <div class="pc-notice">
              <div class="pc-notice-icon">
                <v-icon color="light-blue darken-2">mdi-account-lock</v-icon>
              </div>
              <div>
                <div class="font-weight-bold pc-notice-title">Su clave actual requiere cambio</div>
                <div class="text-body-2 pc-copy">
                  Detectamos que la clave de acceso coincide con su documento de identidad. Esta configuracion es vulnerable y debe reemplazarse por una clave privada.
                </div>
              </div>
            </div>

            <v-list dense class="pc-list">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="green darken-2">mdi-check-circle-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Use una clave que solo usted conozca.</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="green darken-2">mdi-check-circle-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>No use su CI como inicio de la nueva clave.</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="light-blue darken-2">mdi-login-variant</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Al guardar, la sesion se cerrara para ingresar nuevamente.</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" lg="5" xl="4">
        <v-card outlined class="pc-card fill-height">
          <v-card-title class="pc-card-title">
            <v-icon color="light-blue darken-2" class="mr-2">mdi-form-textbox-password</v-icon>
            Nuevos datos de acceso
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <Datos v-on:onaccesschange="onaccesschange()" />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <notifications group="auth" position="bottom right" />
  </v-container>
</template>

<script>
import Datos from '@/components/AClave.vue'
import {parseJsonError} from '@/components/Utils.js'
import gql from 'graphql-tag'
export default {
  data(){
    return{
      img_logo: process.env.VUE_APP_LOGO,
      usuario:{
        cargos: [],
      }
    }
  },
  components:{Datos},
  methods:{
    parseUs(){
      if( this.usuario.seg_apellido == null ) this.usuario.seg_apellido = '';
      return this.usuario.nombres+' '+this.usuario.pri_apellido+' '+this.usuario.seg_apellido; 
    },
    salir(){
      window.localStorage.clear();
      window.sessionStorage.clear();
      this.$store.state.isLogin = false;
      //window.location.reload();
      this.activado = false;
      // window.location.href = "/portal"
      window.location.href = '/portal'
    },
    getDatos(){
      var sql = gql`query{getUsuario(id:${this.usuario.id}){ id,datos_personales{id,nombres,pri_apellido,seg_apellido},cargos{cargo{nombre},sede{nombre}}}}`

      this.$apollo.mutate({
          mutation: sql,
      }).then((data) => {
        this.usuario = data.data.getUsuario.datos_personales;
        this.usuario.cargos = data.data.getUsuario.cargos; 

      }).catch((error) => {
        window.console.error(window.stringifyObject(error));
        this.$notify( parseJsonError( error,'getUsuario' ) )
      })
    },
    onaccesschange(){ 
      this.salir();
      /*this.$router.push("/");
      window.location.reload(true);*/
    }
  },
  mounted(){
    this.usuario = this.$store.state.DATA_USER;
    this.getDatos();
  }
}
</script>

<style scoped>
.perfil-change-page {
  min-height: calc(100vh - 64px);
  background: #f6f9fd;
}

.pc-hero {
  background:
    linear-gradient(135deg, rgba(255,255,255,.95) 0%, rgba(238,248,255,.97) 52%, rgba(201,234,255,.92) 100%),
    linear-gradient(90deg, #edf8ff 0%, #ffffff 100%);
  border: 1px solid #d9edf9;
  border-radius: 8px;
}

.pc-hero-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.pc-avatar {
  border: 1px solid #c7e7f8;
  box-shadow: 0 10px 26px rgba(21, 101, 192, .15);
  flex: 0 0 auto;
}

.pc-title {
  color: #17456f;
}

.pc-subtitle,
.pc-copy {
  color: #557085;
}

.pc-card {
  border-radius: 8px;
  background: #fff;
}

.pc-card-title {
  color: #17456f;
  font-size: 16px;
  font-weight: 700;
}

.pc-notice {
  display: flex;
  gap: 12px;
  padding: 12px;
  border: 1px solid #d5ecfb;
  border-radius: 8px;
  background: #f5fbff;
}

.pc-notice-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  flex: 0 0 auto;
}

.pc-notice-title {
  color: #17456f;
  margin-bottom: 4px;
}

.pc-list {
  margin-top: 12px;
}

@media (max-width: 600px) {
  .pc-hero-content {
    align-items: flex-start;
  }
}
</style>
